var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.943,
    height: 18.597,
    viewBox: "0 0 17.943 18.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pdf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M25.309,145H10.635A1.636,1.636,0,0,0,9,146.635v6.538a1.636,1.636,0,0,0,1.635,1.635H25.309a1.636,1.636,0,0,0,1.635-1.635v-6.538A1.636,1.636,0,0,0,25.309,145Zm-12,5.751-.6,0v1.257a.545.545,0,0,1-1.09,0l-.008-4.139a.545.545,0,0,1,.545-.547h1.153a1.713,1.713,0,1,1,0,3.427Zm4.677,1.672c-.325.006-1.136.009-1.171.009h0a.545.545,0,0,1-.545-.543c0-.015-.008-4.019-.008-4.019a.545.545,0,0,1,.545-.546h1.138c1.3,0,2.167,1.026,2.167,2.554A2.309,2.309,0,0,1,17.99,152.423Zm5.583-3.125a.545.545,0,1,1,0,1.09h-.989v1.549a.545.545,0,0,1-1.09,0v-4.11a.545.545,0,0,1,.545-.545h1.666a.545.545,0,1,1,0,1.09H22.585v.927Z",
    transform: "translate(-9 -139.733)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M239.619,239h-.592c0,.492,0,2.452.005,2.926.227,0,.47,0,.611-.006.728-.013,1.054-.74,1.054-1.455C240.7,240.121,240.619,239,239.619,239Z",
    transform: "translate(-230.672 -230.319)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M111.651,239h-.606c0,.242,0,.5,0,.624,0,.144,0,.394,0,.626l.6,0a.624.624,0,1,0,0-1.247Z",
    transform: "translate(-107.339 -230.319)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M78.71,4.177a2.719,2.719,0,0,0-.582-.94L75.865.85A2.736,2.736,0,0,0,73.888,0H66.634A1.636,1.636,0,0,0,65,1.635V4.177Z",
    transform: "translate(-62.966)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M65,445v.8a1.636,1.636,0,0,0,1.635,1.635H77.241a1.636,1.636,0,0,0,1.635-1.635V445Z",
    transform: "translate(-62.966 -428.837)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.57ab5122cabbd0027ea7ab10f33ed20c.svg";
export { ForwardRef as ReactComponent };